import { render } from "./SectionLayout.vue?vue&type=template&id=8202f556&scoped=true"
import script from "./SectionLayout.vue?vue&type=script&lang=js"
export * from "./SectionLayout.vue?vue&type=script&lang=js"

import "./SectionLayout.vue?vue&type=style&index=0&id=8202f556&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8202f556"]])

export default __exports__